import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  },
  row: {
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  name: {
    fontWeight: 600
  },
  statusChip: {
    marginLeft: theme.spacing(1)
  },
  pagination: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center'
  },
  linkButton: {
    marginTop: theme.spacing(1)
  }
}));

export default useStyles;
